'use strict';

var React = require('react');

var SvgReplayMinor = function SvgReplayMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.53 3.47a.75.75 0 1 0-1.06 1.06l1.72 1.72h-2.69a5 5 0 0 0 0 10h.5a4.75 4.75 0 0 0 4.75-4.75.75.75 0 0 0-1.5 0 3.25 3.25 0 0 1-3.25 3.25h-.5a3.5 3.5 0 1 1 0-7h2.69l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06l-3-3Z"
  }));
};
SvgReplayMinor.displayName = "ReplayMinor";

exports.SvgReplayMinor = SvgReplayMinor;
